import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const CapturePlacesService = {
    list: async (data) => axios.post(API_KEEPER + "/general/capturePlace/list", data, {headers: {'Content-Type': 'application/json'}}).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/getCapture/${id}`).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_KEEPER + `/general/capturePlace/create`, data).then(({data}) => data).catch((err) => { throw err }),
    edit: async (data) => axios.post(API_KEEPER + `/general/capturePlace/update`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_KEEPER + `/general/capturePlace/delete/${id}`).then(({data}) => data).catch((err) => { throw err }),
    options: async () => axios.get(API_KEEPER + "/general/capturePlace/options").then(({data}) => data.data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    listAllowed: async () => axios.get(API_URL + `/capture-places/allowed-capture-places`).then(({data}) => data).catch((err) => { throw err }),
    getList: async () => axios.get(API_KEEPER + `/captureplace/web/all`).then(({data}) => data).catch((err) => { throw err }),
}

export default CapturePlacesService;
